var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 27.875,
    viewBox: "0 0 20 27.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 27.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M7.938-9.344a2.74,2.74,0,0,1,.813-1.969,3.867,3.867,0,0,1,.563-.437L9-12.281a4.009,4.009,0,0,0-.687.531,3.356,3.356,0,0,0-1,2.406,3.3,3.3,0,0,0,1,2.406,3.467,3.467,0,0,0,1.5.875l.156-.594a2.8,2.8,0,0,1-1.25-.719A2.789,2.789,0,0,1,7.938-9.344Z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M13.969-8.25a3.5,3.5,0,0,0-.312-2.844l-.531.313a2.846,2.846,0,0,1,.25,2.312Z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M15.219-6.562l-.656.656-.437-.437a4.508,4.508,0,0,0-.219-6.187,4.546,4.546,0,0,0-6.437,0,4.545,4.545,0,0,0,0,6.437A4.6,4.6,0,0,0,10.688-4.75a4.459,4.459,0,0,0,2.969-1.125l.438.438-.656.656L18.219,0,20-1.781Zm-7.25,0a3.9,3.9,0,0,1,0-5.531A3.982,3.982,0,0,1,10.75-13.25a3.9,3.9,0,0,1,2.781,1.156,3.9,3.9,0,0,1,0,5.531A3.942,3.942,0,0,1,7.969-6.562Zm6.406,1.719.844-.844,3.906,3.906-.844.844Z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M.625-22.031,6.75-27.25H16.906V-7.562h.625V-27.875H6.5L0-22.312V-2.031H13.531v-.625H.625Z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M6.313-22.5H1.5v.625H6.938v-4.5H6.313Z",
    fill: "#00b3ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectOverview);
export default __webpack_public_path__ + "static/media/projectOverview.0530f16af35fe53f3b80ee90f3481953.svg";
export { ForwardRef as ReactComponent };